import { ChevronRight, CalendarCheck, Share2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { shareOrCopy } from "@/lib/share";
import Reveal from "@/components/Reveal";

export default function PickupBanner() {
  const navigate = useNavigate();

  return (
    <section id="enlevement" className="px-[2.4cqw] pt-[3cqw] pb-[2cqw]" data-testid="pickup-banner">
      <Reveal>
        <button
          onClick={() => navigate("/vins")}
          className="group w-full flex items-center gap-[3.6cqw] rounded-[3.6cqw] px-[4.8cqw] py-[2.8cqw] text-left bg-[#64131A] lifted"
          data-testid="pickup-banner-cta"
        >
          <img
            src="/assets/mockup/pickup-icon.png"
            alt=""
            className="object-contain shrink-0 no-frame"
            style={{ width: "12.5cqw", height: "12cqw" }}
          />
          <span className="self-stretch bg-[#FAF6F0]/25 shrink-0" style={{ width: "1px" }} />
          <span className="flex-1 min-w-0">
            <span className="block font-display text-[4cqw] font-medium text-[#FAF6F0] leading-[1.25]">
              Enlèvement à notre
              <br />
              restaurant de Belfort
            </span>
            <span
              className="block mt-[1.2cqw] font-eyebrow text-[1.8cqw] font-semibold tracking-[0.14em] text-[#E8D8B0] uppercase"
              data-testid="pickup-banner-address"
            >
              Commandez sur notre application et retirez sur place.
            </span>
          </span>
          <ChevronRight
            strokeWidth={1.4}
            className="shrink-0 text-[#FAF6F0] transition-transform duration-300 group-hover:translate-x-1"
            style={{ width: "4.5cqw", height: "4.5cqw" }}
          />
        </button>

        <div
          role="button"
          tabIndex={0}
          onClick={() => navigate("/reserver")}
          onKeyDown={(e) => e.key === "Enter" && navigate("/reserver")}
          className="group w-full flex items-center gap-[3.6cqw] rounded-[3.6cqw] px-[4.8cqw] py-[2.2cqw] mt-[2cqw] text-left bg-[#FAF6F0] border border-[#6B1226]/20 lifted cursor-pointer"
          data-testid="reserve-banner-cta"
        >
          <span className="shrink-0 rounded-full bg-[#6B1226] text-[#FAF6F0] flex items-center justify-center" style={{ width: "9cqw", height: "9cqw" }}>
            <CalendarCheck style={{ width: "4.2cqw", height: "4.2cqw" }} strokeWidth={1.6} />
          </span>
          <span className="flex-1 min-w-0">
            <span className="block font-display text-[3.6cqw] font-medium text-[#6B1226] leading-[1.25]">Réserver une table</span>
            <span className="block mt-[0.8cqw] font-eyebrow text-[1.7cqw] font-semibold tracking-[0.14em] text-[#8C6D23] uppercase">
              Midi &amp; soir — en 30 secondes, sans appeler
            </span>
          </span>
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              shareOrCopy({
                title: "Réservez votre table — Le Bistroquet, Belfort",
                text: "Réservez votre table au Bistroquet en 30 secondes, sans appeler :",
                url: `${window.location.origin}/api/share/reservation`,
                image: `${window.location.origin}/api/share/reservation/card.jpg`,
                copiedMsg: "Lien de réservation copié — partagez-le à vos clients",
              });
            }}
            onKeyDown={(e) => e.key === "Enter" && e.stopPropagation()}
            className="shrink-0 rounded-full border border-[#6B1226]/25 text-[#6B1226] flex items-center justify-center hover:bg-[#6B1226] hover:text-[#FAF6F0] transition-colors"
            style={{ width: "8cqw", height: "8cqw" }}
            data-testid="reserve-banner-share"
            aria-label="Partager la page de réservation"
            title="Partager la page de réservation"
          >
            <Share2 style={{ width: "3.6cqw", height: "3.6cqw" }} strokeWidth={1.6} />
          </span>
          <ChevronRight
            strokeWidth={1.4}
            className="shrink-0 text-[#6B1226] transition-transform duration-300 group-hover:translate-x-1"
            style={{ width: "4.5cqw", height: "4.5cqw" }}
          />
        </div>
      </Reveal>
    </section>
  );
}
